  class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    const swatchItem = event.target.closest('li[data-handle]');
    if (!swatchItem) return;

    const swatchHandle = swatchItem.getAttribute('data-handle');
    const anchor = swatchItem.querySelector('a');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    const productUrl = `${href}?view=indexeddbproducts`;

    try {
      const response = await fetch(productUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const htmlText = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlText;

      const newProduct = tempDiv.querySelector('.grid-product');  
      if (!newProduct) throw new Error('No .grid-product found in fetched HTML');

      const oldProduct = swatchItem.closest('.grid-product');
      let index = oldProduct.dataset.index;
      if (oldProduct && newProduct) {
        oldProduct.replaceWith(newProduct);
        newProduct.dataset.index = index ;
        if(newProduct.querySelector('.modal')){
        newProduct.querySelector('.modal').dataset.index =  index;
        }
        theme.reinitProductGridItem(newProduct);

      }
    } catch (error) {
      console.error('Failed to fetch and replace product:', error);
    }
  }
}

customElements.define('product-swatches', ProductSwatches);